import type { ProfilePlanListView } from './PlanListViewTabs';
import type {
  PlanSourceAccess,
  PlanSourceType,
  PlanStudioAssignmentState,
  PlanStudioPlanStatus,
  PlanStudioSavedPlan,
} from './types';

export type ProfilePlanListRequest =
  | PlanStudioPlanStatus
  | {
      status: PlanStudioPlanStatus;
      assignmentState: PlanStudioAssignmentState;
    };

export interface PlanCardSourceMeta {
  sourceType: PlanSourceType;
  sourceName: string;
  sourceAccess: PlanSourceAccess;
  enabledForProfile: boolean;
}

const planAssignmentSortOrder: Record<PlanStudioAssignmentState, number> = {
  in_progress: 0,
  not_started: 1,
  completed: 2,
  cancelled: 3,
};

const savedPlanAssignmentPriority = (plan: PlanStudioSavedPlan): number => {
  if ((plan.assignment_counts?.in_progress ?? 0) > 0) {
    return planAssignmentSortOrder.in_progress;
  }

  return planAssignmentSortOrder[plan.assignment?.state ?? 'not_started'];
};

export const profilePlanListRequest = (
  view: ProfilePlanListView
): ProfilePlanListRequest =>
  view === 'history'
    ? { status: 'active', assignmentState: 'completed' }
    : view;

export const savedPlanMatchesListView = (
  plan: PlanStudioSavedPlan,
  listView: ProfilePlanListView
): boolean =>
  listView === 'history'
    ? plan.status === 'active' && plan.assignment?.state === 'completed'
    : plan.status === listView &&
      (listView !== 'active' ||
        (plan.assignment?.state !== 'completed' &&
          plan.assignment?.state !== 'cancelled'));

export const sortSavedPlansByAssignmentPriority = (
  plans: PlanStudioSavedPlan[]
): PlanStudioSavedPlan[] =>
  plans
    .map((plan, index) => ({ plan, index }))
    .sort((left, right) => {
      const priority =
        savedPlanAssignmentPriority(left.plan) -
        savedPlanAssignmentPriority(right.plan);

      return priority || left.index - right.index;
    })
    .map(({ plan }) => plan);
